import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mini:false,
  },
  mutations: {
    SET_ENV(state, env){
      state.mini= env
    }
  },
  actions: {
  },
  modules: {
  }
})
